import { useCallback, useState } from 'react'
import { httpsCallable, getFunctions } from 'firebase/functions'
import byEndpoint from './by-endpoint'
import byEnv from './by-env'

const getDataFns = (grouping) => {
  switch (grouping) {
    case 'endpoint': return byEndpoint
    case 'env': return byEnv
    default: return byEndpoint
  }
}

const CUSTOMER_EXCLUDED_ENDPOINTS = ['BASIC-NEW', 'BASIC-REPEAT']

const useGetAnalytics = (key, timeFrame, env = 'all', grouping = 'environment', role = 'admin', api = 'MediPro') => {
  // console.log('useGetAnalytics hook', key, timeFrame)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const [data, setGraphData] = useState()
  const [listData, setListData] = useState()
  const [input, setInput] = useState({ key, timeFrame, env, grouping, api })
  const [pieData, setPieData] = useState([])
  const [detailData, setDetailData] = useState([])

  const refreshData = () => {
    const fetch = async () => {
      setGraphData()
      setLoading(true)
      const getAnalyticsData = httpsCallable(getFunctions(), 'getAnalytics')
      try {
        const res = await getAnalyticsData({ key: input.key, timeFrame: input.timeFrame, env: input.env, api: input.api })

        // Sanitize IDEON references in method/endpoint fields
        const sanitized = (res.data || []).map((hit) => ({
          ...hit,
          method: typeof hit.method === 'string' ? hit.method.replace(/IDEON/gi, 'PROVIDER') : hit.method,
          endpoint: typeof hit.endpoint === 'string' ? hit.endpoint.replace(/IDEON/gi, 'PROVIDER') : hit.endpoint
        }))

        // Exclude restricted endpoints for customer users
        const filteredData = role === 'customer'
          ? sanitized.filter((hit) => !CUSTOMER_EXCLUDED_ENDPOINTS.some((ex) => hit.endpoint?.includes(ex)))
          : sanitized

        const { filterData, createListData, createPieData, createDetailData } = getDataFns(input.grouping)

        const filtered = filterData(filteredData, input)
        const list = createListData(filteredData)
        const pie = createPieData(list)
        const detail = createDetailData ? createDetailData(filteredData) : []

        setPieData(pie)
        setGraphData(filtered)
        setListData(list)
        setDetailData(detail)

        // console.log(filtered)
      } catch (error) {
        setError(JSON.stringify(error))
      }
      setLoading(false)
    }

    if (input.key && input.timeFrame) {
      fetch()
    }
  }

  // this allows only sending individual field changes
  const update = useCallback((changes) => {
    setInput({
      ...input,
      ...changes
    })
  }, [input, setInput])

  return {
    settings: input,
    loading,
    error,
    data,
    listData,
    detailData,
    update,
    pieData,
    refreshData
  }
}

export default useGetAnalytics
